module.exports = __webpack_public_path__ + "static/media/bootstrap.f27c340d.png";